/*@ngInject*/
const SubmissionStateMediator = function (submissionStateModel) {

    this.saveSubmissionStateUrl = function (submissionId, stateName, stateParams) {
        submissionStateModel.saveStateUrl(submissionId, stateName, stateParams);
    };

    this.getSubmissionStateUrl = function (submissionId) {
        return submissionStateModel.getStateUrl(submissionId);
    };

    this.getNewSubmissionState = function () {
        return submissionStateModel.getNewSubmission();
    };

    this.saveNewSubmissionState = function (submission) {
        submissionStateModel.saveNewSubmission(submission);
    };

    this.deleteNewSubmissionState = function () {
        submissionStateModel.deleteNewSubmission();
    };

    this.getSubmissionDrawerState = function (submissionId) {
        return submissionStateModel.getDrawerState(submissionId);
    };

    this.saveSubmissionDrawerState = function (submissionId, state) {
        submissionStateModel.saveDrawerState(submissionId, state);
    };

    this.saveChecklistState = function (submissionId, data) {
        return submissionStateModel.saveChecklist(submissionId, data);
    };

    this.getChecklistState = function (submissionId) {
        return submissionStateModel.getChecklist(submissionId);
    };

    this.saveCollaborationState = function (submissionId, data) {
        return submissionStateModel.saveCollaboration(submissionId, data);
    };

    this.getCollaborationState = function (submissionId) {
        return submissionStateModel.getCollaboration(submissionId);
    };

    this.saveActivityStreamState = function (submissionId, data) {
        return submissionStateModel.saveActivityStream(submissionId, data);
    };

    this.getActivityStreamState = function (submissionId) {
        return submissionStateModel.getActivityStream(submissionId);
    };

    this.saveSnippetsViewerPositionState = function(submissionId, x, y, isOpen, isAttached) {
        return submissionStateModel.saveSnippetsViewerPosition(submissionId, x, y, isOpen, isAttached);
    };

    this.getSnippetsViewerPositionState = function (submissionId) {
        return submissionStateModel.getSnippetsViewerPosition(submissionId);
    };

    this.openChatCollaboration = function (submissionId) {
        return submissionStateModel.openChatCollaboration(submissionId);
    };
};

angular.module('gw-um-submission').service('submissionStateMediator', SubmissionStateMediator);
